export default __webpack_public_path__ + "static/media/elevate-dmb-banner-2.16e12b22.jpg";